import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useObserver } from "mobx-react-lite";
import { useStores } from "../../../store";
import { DownloadResume } from "../resume_output";

const Resume10 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload} />
      <div className="flex flex-col items-center p-6">
        <div
          className="w-full max-w-4xl bg-gray-50 border-2 border-gray-200 shadow-lg rounded-md"
          ref={resumeRef}
        >
          <div className="flex flex-col md:flex-row">
            <div className="bg-yellow text-white p-6 w-full md:w-1/3">
              <div className="flex flex-col items-center">
                <img
                  src={
                    ResumeStore?.resumeBuilder?.profile ??
                    "https://images.unsplash.com/photo-1508341591423-4347099e1f19?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWVufGVufDB8fDB8fHww"
                  }
                  className="rounded-full w-40 h-40 mx-auto"
                />
                <h2 className="text-xl font-bold mb-2">{`${ResumeStore?.resumeBuilder.personalDetails?.firstName} ${ResumeStore?.resumeBuilder.personalDetails?.lastName}`}</h2>
                <div className="text-sm mb-2">
                  {ResumeStore?.resumeBuilder.personalDetails?.jobTitle}
                </div>
                <div className="text-sm mb-2">
                  {ResumeStore?.resumeBuilder.personalDetails?.city},{" "}
                  {ResumeStore?.resumeBuilder.personalDetails?.country}{" "}
                  {ResumeStore?.resumeBuilder.personalDetails?.postalCode}
                </div>
                <div className="text-sm mb-2">
                  {ResumeStore?.resumeBuilder.personalDetails?.email}
                </div>
              </div>
              <div className="mt-6">
                <h3 className="text-lg font-bold mb-2">Skills</h3>
                <ul className="list-disc list-inside">
                  {ResumeStore?.resumeBuilder.skills?.map((skill, index) => (
                    <li key={index} className="text-sm">
                      {skill}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-6">
                <h3 className="text-lg font-bold mb-2">Hobbies</h3>
                <ul className="list-disc list-inside">
                  {ResumeStore?.resumeBuilder.hobbies?.map((hobby, index) => (
                    <li key={index} className="text-sm">
                      {hobby}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-6">
                <h3 className="text-lg font-bold mb-2">Languages</h3>
                <ul className="list-disc list-inside">
                  {ResumeStore?.resumeBuilder.languages.map((lang, index) => (
                    <li
                      key={index}
                      className="text-sm"
                    >{`${lang.language} - ${lang.level}`}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="p-6 w-full md:w-2/3">
              <h2 className="text-2xl font-bold text-indigo-900 mb-4">
                Professional Summary
              </h2>
              <p className="text-sm mb-6">
                {ResumeStore?.resumeBuilder.profileSummary}
              </p>
              <h2 className="text-2xl font-bold text-indigo-900 mb-4">
                Work History
              </h2>
              {ResumeStore?.resumeBuilder.employementHistory.map(
                (job, index) => (
                  <div key={index} className="mb-6">
                    <div className="text-sm font-bold text-red-500 mb-1">{`${job.startDate} - ${job.endDate}`}</div>
                    <div className="text-sm font-bold">{job.jobTitle}</div>
                    <div className="text-sm">
                      {job.company}, {job.city}
                    </div>
                    <ul className="list-disc list-inside ml-4">
                      {job.description?.split("\n")?.map((desc, i) => (
                        <li key={i} className="text-sm">
                          {desc}
                        </li>
                      ))}
                    </ul>
                  </div>
                )
              )}
              <div className="mt-6">
                <h2 className="text-2xl font-bold text-indigo-900 mb-4">
                  Education
                </h2>
                {ResumeStore?.resumeBuilder.education.map((edu, index) => (
                  <div key={index} className="mb-4">
                    <div className="text-sm font-bold">{edu.degree}</div>
                    <div className="text-sm">{edu.school}</div>
                    <div className="text-sm">{edu.city}</div>
                    <div className="text-sm">{`${edu.startDate} - ${edu.endDate}`}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ));
};

export default Resume10;
